export enum AdditionalRateTypes {
    DAILY_24HOURS = 1,
    NIGHT_SHIFT_CALL = 2,
    CALL_BACK = 3,
    WEEKEND_CALL = 4
}
